import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ClosableModal from "components/source/shared/closable-modal";
import GridSuperBarTopFiltersAvailability from "./grid-superbar-top-filters-availability";
import { canRefreshGrid, refreshGrid } from "helpers/next-grid-helpers";

const modalName = "grid-availability-modal";

export class GridAvailabilityModal extends React.Component {
  static propTypes = {
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    gridMigratedToNext: PropTypes.bool,
    isMobileViewport: PropTypes.bool,
    isSubscriber: PropTypes.bool,
    membershipState: PropTypes.object,
    onChange: PropTypes.func,
    onClickBrowse: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    shouldHideReserveLens: PropTypes.bool,
  };

  static modalName = modalName;

  onChange = filter => {
    if (canRefreshGrid(filter, this.props.gridMigratedToNext)) {
      refreshGrid(filter, this.props.membershipState);
      return;
    }

    this.props.onChange(filter);
    // setTimeout without delay defers the callback execution until the current execution queue has completed
    setTimeout(() => this.props.onClickBrowse(), 0);
  };

  render() {
    const { isMobileViewport, displayedModal, isSubscriber, onRequestClose } = this.props;
    const mobileStyles = {
      content: {
        bottom: 0,
      },
    };
    const styles = isMobileViewport ? mobileStyles : {};

    return (
      <ClosableModal
        additionalStyles={styles}
        isOpen={displayedModal === modalName}
        onRequestClose={onRequestClose}
        optionalClass="grid-filter-modal availability-modal grid-superbar">
        <GridSuperBarTopFiltersAvailability
          isSubscriber={isSubscriber}
          onClickBrowse={this.onChange}
          shouldHideReserveLens={this.props.shouldHideReserveLens}
        />
      </ClosableModal>
    );
  }
}

const mapStateToProps = state => {
  return {
    displayedModal: state.displayedModal,
    gridMigratedToNext: state.migratedToNext,
    isMobileViewport: state.browser?.isMobileViewport || false,
    membershipState: state.membershipState,
    nextGridType: state.nextGridType,
    workingFilters: state.workingFilters,
  };
};

export default connect(mapStateToProps)(GridAvailabilityModal);
